import { Box } from '@chakra-ui/react';
import styled from '@emotion/styled';

export const StyledLeftDrawerContainer = styled(Box)((props) => ({
  overflowX: 'hidden',
  overflowY: 'hidden',
  backgroundColor: `${props.theme.colors?.gray[50]}`,
  transition: 'all 0.5s ease-in-out',
  opacity: 1,
  width: '200px',
  maxWidth: '100%',
  zIndex: 1000,
  boxSizing: 'border-box',
  flex: 1,
  borderTop: `1px solid ${props.theme.colors?.gray[200]}`,
}));
